import { IMedia } from 'src/types';
import { useTheme } from '@mui/material';

import { HoverWrapper } from 'src/components';
import { MediaRender } from '../media-render';
import { ItemSt, LinkSt, MediaListSt, TitleSt, mediaSt } from './media-list.styled';

interface IProps {
  media: IMedia[];
  size?: number;
}

export const MediaList = ({ media, size }: IProps) => {
  const theme = useTheme();

  return (
    <MediaListSt id="index__components-media-list__medialistst__l17">
      {media.map((item) => {
        return (
          <HoverWrapper key={item.id} title={item.title}>
            <ItemSt id="index__components-media-list__itemst__l21">
              <LinkSt id="index__components-media-list__linkst__l22" size={size}>
                <MediaRender
                  className={mediaSt(theme)}
                  type={item.type}
                  alt={item.title}
                  link={item.link_small || item.link}
                  modalLink={item.link_large || item.link} />
                
              </LinkSt>
              <TitleSt id="index__components-media-list__titlest__l31">{item.title}</TitleSt>
            </ItemSt>
          </HoverWrapper>);

      })}
    </MediaListSt>);

};